import React, { useEffect, useRef } from "react";
import Highcharts, { Options } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ChartBarleySoftWheat } from "../../../redux/actions/dashboard/dashboardTypes";

interface DynamicChartCountActionsProps {
  dynamicChart: ChartBarleySoftWheat[];
  t: (arg0: string) => string;
  loading: boolean;
}

const DynamicChartCountActions: React.FC<DynamicChartCountActionsProps> = ({
  dynamicChart,
  t,
  loading,
}) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (loading) {
        chart.showLoading(`...${t("Common_options.Loading")}`);
      } else {
        chart.hideLoading();
      }
    }
  }, [loading, t]);

  const chartOptions: Options = {
    colors: ["#7BB4EC", "#50B432"],
    chart: {
      type: "column",
    },
    loading: {
      hideDuration: 300,
      showDuration: 300,
      labelStyle: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
      },
      style: {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
      },
    },

    title: {
      text: t("Dashboard.cereal_charts.distribution_by_variety"),
    },

    series: [
      {
        name: t("Dashboard.number_of_actions"),
        data: dynamicChart.map((u: ChartBarleySoftWheat) => u?.actions),
      } as any,
    ],
    yAxis: {
      title: {
        text: "",
      },
    },
    xAxis: {
      categories: dynamicChart.map((u: ChartBarleySoftWheat) => u.variety),
    },
  };

  return (
    <HighchartsReact
      ref={chartRef}
      containerProps={{
        style: {
          width: "100%",
        },
      }}
      highcharts={Highcharts}
      options={chartOptions}
    />
  );
};

export default DynamicChartCountActions;
